import routerOptions0 from "/usr/src/app/content/n3-packages-512175ad-2464-4494-9589-52dec312d927/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}